module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/notavailable.963171f6.png";